import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthRouteGuard } from 'src/app/auth-route-guard.service';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'schedule',
    loadChildren: () => import('./pages/schedule/schedule.module').then((m) => m.SchedulePageModule),
    canActivate: [AuthRouteGuard]
  },
  {
    path: 'move-overview',
    loadChildren: () => import('./pages/move-overview/move-overview.module').then((m) => m.MoveOverviewModule),
    canActivate: [AuthRouteGuard]
  },
  {
    path: 'inventory',
    loadChildren: () => import('./pages/inventory/inventory.module').then((m) => m.InventoryModule),
    canActivate: [AuthRouteGuard]
  },
  {
    path: 'cloud-sync',
    loadChildren: () => import('./pages/cloud-sync/cloud-sync.module').then((m) => m.CloudSyncModule),
    canActivate: [AuthRouteGuard]
  },
  {
    path: 'settings',
    loadChildren: () => import('./pages/settings/settings.module').then((m) => m.SettingsModule),
    canActivate: [AuthRouteGuard]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, enableTracing: false, useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
